/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from "lodash";
import React from "react";
import Reflux from "reflux";
import moment from "moment";
import classNames from "classnames";
import logger from "../../utils/LoggerFrontend";
import StatusStore from "../../Stores/StatusStore";
import Actions from "../../Actions";
import CampaignCreateSupportPanel from "../SelfServiceCampaignCreation/Previews/Campaign__Create_SupportPanel.jsx";
import CampaignLeftSidebar from "./Campaign__Left-Sidebar.jsx";
import { isCampaignManagerAvailable, renderStatus } from "../../utils/Helpers";
import CampaignReadPoEditModal from "./Campaign__Read-PoEditModal.jsx";
import CampaignReadEditEndDate from "./CampaignReadEndDate/CampaignReadEditEndDate.jsx";
import CampaignMembers from "../../Components/CampaignMembers";
import * as Styled from "../../PagesAdmin/AdminPanel/Campaign__AdminRead--Styles.jsx";

// eslint-disable-next-line import/no-unresolved
import { Button as BtnPrimary, Store__System } from "@talentbait/shared-components";
import { ONLYFY } from "./constants.js";
import { getPermissions } from "../../Permissions/index.js";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { RecruiteeIntegration } from "./integration/RecruiteeIntegration.jsx";
import { RexxIntegration } from "./integration/RexxIntegration.jsx";
import { MhmIntegration } from "./integration/MhmIntegration.jsx";
import { ExternalLinkIcon } from "../../Components/Icons/ExternalLink.jsx";

class CampaignInProgress extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {
      heightY: 0,
      isCampaignActionsOpen: false
    };

    this.stores = [Store__System, StatusStore];

    Actions.getAllCampaignManagers();
  }

  onSaveIntegration(update) {
    logger.log("Campaign_InProgess:onSaveIntegration", "called", update);
    this.setState({
      campaignData: { ...this.state.campaignData, ...update }
    });
  }

  integrateRecruitee(e) {
    e.preventDefault();

    // TODO: Check not on user's logged in orga but on the orga of the campaign
    const { campaignId, t } = this.props;
    const { organization, campaignData } = this.state;

    Actions.toggleModal("showGenericModal", true, {
      headline: t("Select a job"),
      widthVersion: "small",
      view: (
        <div style={{ padding: 15 }}>
          <RecruiteeIntegration
            headline={t("Select a job")}
            btnLabel={t("use this job")}
            organization={organization}
            campaignData={campaignData}
            campaignId={campaignId}
            onSaveIntegration={this.onSaveIntegration.bind(this)}
          />
        </div>
      )
    });

    this.setState({
      isCampaignActionsOpen: false,
      showIntegrations: true
    });
  }

  // Copied from Campaign__Read.jsx
  integrateRexx(e) {
    e.preventDefault();

    // TODO: Check not on user's logged in orga but on the orga of the campaign
    const { campaignId, t } = this.props;
    const { organization, campaignData } = this.state;

    Actions.toggleModal("showGenericModal", true, {
      headline: t("Select a job"),
      widthVersion: "small",
      view: (
        <div style={{ padding: 15 }}>
          <RexxIntegration
            headline={t("Select a job")}
            btnLabel={t("use this job")}
            organization={organization}
            campaignData={campaignData}
            campaignId={campaignId}
            onSaveIntegration={this.onSaveIntegration.bind(this)}
          />
        </div>
      )
    });

    this.setState({
      isCampaignActionsOpen: false,
      showIntegrations: true
    });
  }

  integrateMhm(e) {
    e.preventDefault();

    // TODO: Check not on user's logged in orga but on the orga of the campaign
    const { campaignId, t } = this.props;
    const { organization, campaignData } = this.state;

    Actions.toggleModal("showGenericModal", true, {
      headline: t("Set an address"),
      widthVersion: "small",
      view: (
        <div style={{ padding: 15 }}>
          <MhmIntegration
            headline={t("Set an address")}
            btnLabel={t("Use this address")}
            organization={organization}
            campaignData={campaignData}
            campaignId={campaignId}
            onSaveIntegration={this.onSaveIntegration.bind(this)}
          />
        </div>
      )
    });

    this.setState({
      isCampaignActionsOpen: false,
      showIntegrations: true
    });
  }

  renderCampaignManager(campaignManager) {
    const { t } = this.props;
    const isAvailable = isCampaignManagerAvailable(campaignManager);

    const availabilityStatus = isAvailable ? (
      <span className="user__state user__state--online">{t("Available")}</span>
    ) : (
      <span className="user__state">{t("Available soon")}</span>
    );

    return (
      <div className="expert">
        <img src={campaignManager?.photo} className="expert__img" alt="" />
        <div className="expert__name">
          <strong>{campaignManager?.userName}</strong>
          {availabilityStatus}
          {/* eslint-disable-next-line react-i18n/no-dynamic-translation-keys */}
          <span className="user__position">{t(campaignManager?.role)}</span>
        </div>
      </div>
    );
  }

  openAdmin() {
    const { campaignData, campaignId } = this.props;
    window.open(
      `${window.baseUrlInteralTools}/admin-campaign/${campaignData.organizationId}/${campaignId}`,
      "_blank"
    );
  }

  renderState() {
    const { status, t } = this.props;
    return (
      <span className={`campaignlist__company__state campaign-read__state--${status}`}>
        {renderStatus(status, t)}
      </span>
    );
  }

  renderDateSection() {
    const { campaignData, t } = this.props;
    return (
      <div className="campaign-read__days-left">
        <center>
          {t("Created on")}{" "}
          <strong title={moment(campaignData.createdDate).format("DD.MM.YY")}>
            {moment(campaignData.createdDate).locale("de").format("DD.MM.YYYY")}
          </strong>
        </center>
      </div>
    );
  }

  getCampaignManager(frontUserId) {
    const { campaignManagers = [] } = this.state;
    return _.filter(campaignManagers, { frontUserId })[0];
  }

  toggleMenu() {
    this.setState({
      isCampaignActionsOpen: !this.state.isCampaignActionsOpen
    });
  }

  openPoEditModal() {
    const { campaignData } = this.state;
    const { t } = this.props;

    Actions.toggleModal("showGenericModal", true, {
      headline: t("Edit PO Number"),
      widthVersion: "medium",
      view: (
        <CampaignReadPoEditModal
          campaignId={campaignData?.id}
          poNumber={campaignData?.poNumber}
          onUpdate={() => {
            this.toggleMenu();
          }}
        />
      )
    });
  }

  openEndDateEditModal() {
    const { campaignData, userProfile = {} } = this.state;
    const { t } = this.props;

    Actions.toggleModal("showGenericModal", true, {
      headline: t("Edit End Date"),
      widthVersion: "medium",
      view: (
        <CampaignReadEditEndDate
          campaignId={campaignData?.id}
          orgaId={campaignData?.organizationId}
          campaignStatus={campaignData?.status}
          currentEndDate={campaignData?.endDate}
          campaignDuration={campaignData?.campaignDuration}
          userName={userProfile?.userName}
          onUpdate={this.toggleMenu}
          i18n={t}
        />
      )
    });
  }

  renderMenu() {
    const campaignEditActions = classNames({
      dropdown__list: true,
      "dropdown__list--hidden": !this.state.isCampaignActionsOpen
    });

    const { campaignData, t } = this.props;

    if (campaignData.source === "ONLYFY") {
      return;
    }

    const { organization } = this.state;

    const isSameOrga = organization?.id === campaignData.organizationId;
    // TODO: Check not on user's logged in orga but on the orga of the campaign
    const recruiteeIntegration = isSameOrga && organization?.integrations?.recruitee;
    const rexxIntegration = isSameOrga && organization?.integrations?.rexx;
    const mhmIntegration = isSameOrga && organization?.integrations?.mhm;

    return (
      <div className="campaign-read__actions">
        <a href="#" onClick={this.toggleMenu.bind(this)}>
          <BtnPrimary type="tertiary" variant="outline" size="medium">
            {t("Actions")} <span style={{ fontSize: 8, position: "relative", left: 4 }}>▼</span>
          </BtnPrimary>
        </a>

        <ul className={campaignEditActions}>
          <li>
            <a
              href="#"
              className=""
              onClick={this.openPoEditModal.bind(this)}
              style={{ marginRight: "0px" }}
            >
              {t("Edit PO Number")}
            </a>
          </li>

          <li>
            <a
              href="#"
              className=""
              onClick={this.openEndDateEditModal.bind(this)}
              style={{ marginRight: "0px" }}
            >
              {t("Edit End Date")}
            </a>
          </li>

          <li>
            {recruiteeIntegration && (
              <Link to="#" onClick={this.integrateRecruitee.bind(this)}>
                {t("Synchronize with Recruitee")}
              </Link>
            )}
          </li>
          <li>
            {rexxIntegration && (
              <Link to="#" onClick={this.integrateRexx.bind(this)}>
                {t("Synchronize with Rexx")}
              </Link>
            )}
          </li>
          <li>
            {mhmIntegration && (
              <Link to="#" onClick={this.integrateMhm.bind(this)}>
                {t("Synchronize with MHM")}
              </Link>
            )}
          </li>
        </ul>
      </div>
    );
  }

  render() {
    const { organization, campaignManagers } = this.state;
    const { campaignData, userProfile, campaignId, sortedArray, adsetId, t } = this.props;
    const { campaignGoal } = campaignData;

    logger.debug("CampaignInProgress:render", "called...", {
      campaignManagers
    });

    const campaignManager = this.getCampaignManager(campaignData && campaignData.campaignManager);

    let url =
      campaignData?.source == ONLYFY
        ? `/external/creatives/${campaignId}`
        : adsetId
        ? `/creatives/${campaignId}/${adsetId}`
        : `/creatives/${campaignId}/`;

    if (campaignData?.type === "assistant") {
      url = `/assistant/overview/${campaignId}`;
    }

    const { hasPermissionsToReadCampaign } = getPermissions(userProfile);
    const isOnlyfySource = campaignData?.source == ONLYFY;

    let styles = { right: "20px", top: "80px" };
    if (campaignData?.source == "ONLYFY") {
      styles = { right: "40px", top: "80px" };
    }

    return (
      <div className="campaign-in-preview">
        {!this.props.isExternal && <CampaignLeftSidebar campaigns={sortedArray} />}

        <div
          className={
            "campaign-read__wrapper" +
            (this.props?.isExternal ? "--external" : "") +
            " campaign-read__in-progress fade-in"
          }
        >
          <Styled.AdminOptionsWrapper>
            {!this.props.isExternal && (
              <CampaignMembers
                campaignId={campaignId}
                campaignGoal={campaignGoal}
                hasCollectiveInbox={organization?.hasCollectiveInbox}
              />
            )}

            <div>
              {userProfile && userProfile.superRank === "admin" && (
                <a
                  href="#"
                  className=""
                  onClick={this.openAdmin.bind(this)}
                  style={{
                    marginRight: "10px"
                  }}
                >
                  <BtnPrimary type="tertiary" variant="outline" size="medium">
                    {t("Open admin")}
                  </BtnPrimary>
                </a>
              )}
            </div>

            {this.renderMenu()}
          </Styled.AdminOptionsWrapper>

          <div className="campaign-read__in-progress-wrapper">
            {this.renderState()}
            <h1 className="headline__h1" style={{ marginTop: 20 }}>
              {t("Super! We are setting up your campaign", { jobTitle: campaignData.jobTitle })}
              <a
                title="Link to Job posting"
                className="campaign-read__link"
                href={campaignData.jobPostingUrl}
                target="_blank"
                rel="noreferrer"
              >
                <ExternalLinkIcon />
              </a>
            </h1>
            <p className="headline__subline">
              {t("Hey, I'm")} {campaignManager && campaignManager.userName},{" "}
              {t(
                "your personal recruiting expert. We'll be in touch with you shortly with an update by email. The campaign is currently being created."
              )}
            </p>
            {this.renderDateSection()}
            <div>
              <br />

              {(organization && organization.wantsPreview) ||
              this.props.campaignData?.source == "ONLYFY" ? (
                <a href={url} target="_blank" rel="noreferrer">
                  <BtnPrimary type="primary" size="large" width={"100%"}>
                    {t("View ad preview")}
                  </BtnPrimary>
                </a>
              ) : (
                <></>
              )}
              <br />
              <br />
            </div>
            {this.renderCampaignManager(campaignManager)}
          </div>
        </div>
        {(hasPermissionsToReadCampaign || isOnlyfySource) && (
          <div className="campaign-read__activity" style={styles}>
            <CampaignCreateSupportPanel
              campaignManagers={campaignManagers}
              campaignData={campaignData}
              userProfile={userProfile}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(CampaignInProgress);
